const SimpleTextPage = ({ title, content }) => (
  <div className="min-h-screen pt-20" data-testid={`simple-page-${title.toLowerCase().replace(/\s+/g, '-')}`}>
    <section className="section-spacing">
      <div className="container-custom max-w-4xl">
        <h1 className="text-4xl font-heading font-bold text-brand-pearl mb-8">{title}</h1>
        <div className="prose prose-lg max-w-none text-brand-walnut space-y-4">
          {content}
        </div>
      </div>
    </section>
  </div>
);

export const TermsPage = () => (
  <SimpleTextPage
    title="Terms & Conditions"
    content={
      <>
        <p>Last updated: January 2025</p>
        <h2 className="text-2xl font-heading font-bold text-brand-pearl mt-8 mb-4">1. Agreement to Terms</h2>
        <p>By accessing and using Rudra Apparel's website and services, you agree to be bound by these Terms and Conditions.</p>
        
        <h2 className="text-2xl font-heading font-bold text-brand-pearl mt-8 mb-4">2. Use of Services</h2>
        <p>You may use our services only for lawful purposes and in accordance with these Terms. You agree not to use our services in any way that could damage, disable, or impair our website.</p>
        
        <h2 className="text-2xl font-heading font-bold text-brand-pearl mt-8 mb-4">3. Orders and Payments</h2>
        <p>All orders are subject to acceptance and availability. We reserve the right to refuse or cancel any order. Prices are subject to change without notice.</p>
        
        <h2 className="text-2xl font-heading font-bold text-brand-pearl mt-8 mb-4">4. Bespoke Manufacturing</h2>
        <p>Bespoke uniform orders require consultation and approval of samples. Timelines provided are estimates and may vary based on order complexity and volume.</p>
        
        <h2 className="text-2xl font-heading font-bold text-brand-pearl mt-8 mb-4">5. Intellectual Property</h2>
        <p>All content on this website is the property of Rudra Apparel and is protected by copyright laws.</p>
        
        <h2 className="text-2xl font-heading font-bold text-brand-pearl mt-8 mb-4">6. Limitation of Liability</h2>
        <p>Rudra Apparel shall not be liable for any indirect, incidental, or consequential damages arising from the use of our services.</p>
      </>
    }
  />
);

export const PrivacyPage = () => (
  <SimpleTextPage
    title="Privacy Policy"
    content={
      <>
        <p>Last updated: January 2025</p>
        <h2 className="text-2xl font-heading font-bold text-brand-pearl mt-8 mb-4">1. Information We Collect</h2>
        <p>We collect information you provide directly to us, such as when you create an account, make a purchase, or contact us. This may include your name, email address, phone number, shipping address, and payment information.</p>
        
        <h2 className="text-2xl font-heading font-bold text-brand-pearl mt-8 mb-4">2. How We Use Your Information</h2>
        <p>We use the information we collect to process your orders, communicate with you, improve our services, and comply with legal obligations.</p>
        
        <h2 className="text-2xl font-heading font-bold text-brand-pearl mt-8 mb-4">3. Information Sharing</h2>
        <p>We do not sell or rent your personal information to third parties. We may share your information with service providers who assist us in operating our business.</p>
        
        <h2 className="text-2xl font-heading font-bold text-brand-pearl mt-8 mb-4">4. Data Security</h2>
        <p>We implement appropriate technical and organizational measures to protect your personal information against unauthorized access or disclosure.</p>
        
        <h2 className="text-2xl font-heading font-bold text-brand-pearl mt-8 mb-4">5. Your Rights</h2>
        <p>You have the right to access, correct, or delete your personal information. Contact us at info@rudraapparel.com to exercise these rights.</p>
      </>
    }
  />
);

export const RefundPage = () => (
  <SimpleTextPage
    title="Refund Policy"
    content={
      <>
        <p>Last updated: January 2025</p>
        <h2 className="text-2xl font-heading font-bold text-brand-pearl mt-8 mb-4">1. Return Window</h2>
        <p>You may return ready-to-wear products within 7 days of delivery for a full refund, provided the items are unused, unwashed, and in original packaging with tags attached.</p>
        
        <h2 className="text-2xl font-heading font-bold text-brand-pearl mt-8 mb-4">2. Non-Returnable Items</h2>
        <p>Bespoke and custom-manufactured items cannot be returned or refunded as they are made to your specifications.</p>
        
        <h2 className="text-2xl font-heading font-bold text-brand-pearl mt-8 mb-4">3. Refund Process</h2>
        <p>Once we receive and inspect your return, we will process your refund within 7-10 business days. Refunds will be credited to the original payment method.</p>
        
        <h2 className="text-2xl font-heading font-bold text-brand-pearl mt-8 mb-4">4. Damaged or Defective Items</h2>
        <p>If you receive a damaged or defective item, please contact us within 48 hours of delivery with photos. We will arrange for a replacement or full refund.</p>
        
        <h2 className="text-2xl font-heading font-bold text-brand-pearl mt-8 mb-4">5. Contact Us</h2>
        <p>For return and refund inquiries, contact us at info@rudraapparel.com or +91 98765 43210.</p>
      </>
    }
  />
);

export const ShippingPage = () => (
  <SimpleTextPage
    title="Shipping Policy"
    content={
      <>
        <p>Last updated: January 2025</p>
        <h2 className="text-2xl font-heading font-bold text-brand-pearl mt-8 mb-4">1. Shipping Areas</h2>
        <p>We ship ready-to-wear products across India. Bespoke orders are available nationwide with consultation services.</p>
        
        <h2 className="text-2xl font-heading font-bold text-brand-pearl mt-8 mb-4">2. Shipping Charges</h2>
        <p>Shipping is free on all orders above ₹2,000. For orders below ₹2,000, a flat shipping charge of ₹100 applies.</p>
        
        <h2 className="text-2xl font-heading font-bold text-brand-pearl mt-8 mb-4">3. Delivery Time</h2>
        <p>Ready-to-wear orders are typically delivered within 5-7 business days. Bespoke orders have custom timelines discussed during consultation (typically 20-30 days).</p>
        
        <h2 className="text-2xl font-heading font-bold text-brand-pearl mt-8 mb-4">4. Order Tracking</h2>
        <p>You will receive a tracking number via email once your order is shipped. You can track your order status using this number.</p>
        
        <h2 className="text-2xl font-heading font-bold text-brand-pearl mt-8 mb-4">5. Bulk Orders</h2>
        <p>Bulk order shipping is arranged based on order volume and destination. Contact us for custom shipping quotes.</p>
      </>
    }
  />
);

export const FabricGuidePage = () => (
  <SimpleTextPage
    title="Fabric Guide"
    content={
      <>
        <h2 className="text-2xl font-heading font-bold text-brand-pearl mb-4">Understanding Our Fabrics</h2>
        <p>Choosing the right fabric is essential for uniform durability, comfort, and appearance. Here's our guide to help you select the perfect material.</p>
        
        <h2 className="text-2xl font-heading font-bold text-brand-pearl mt-8 mb-4">Cotton</h2>
        <p><strong>Best for:</strong> All-day comfort, breathability<br/>
        <strong>Ideal for:</strong> School uniforms, office shirts, casual wear<br/>
        <strong>Care:</strong> Easy to wash, may require ironing</p>
        
        <h2 className="text-2xl font-heading font-bold text-brand-pearl mt-8 mb-4">Polyester</h2>
        <p><strong>Best for:</strong> Durability, wrinkle resistance<br/>
        <strong>Ideal for:</strong> Corporate uniforms, frequent-wear items<br/>
        <strong>Care:</strong> Low maintenance, quick drying</p>
        
        <h2 className="text-2xl font-heading font-bold text-brand-pearl mt-8 mb-4">Cotton-Polyester Blends</h2>
        <p><strong>Best for:</strong> Balance of comfort and durability<br/>
        <strong>Ideal for:</strong> Most uniform applications<br/>
        <strong>Care:</strong> Easy care, minimal ironing needed</p>
        
        <h2 className="text-2xl font-heading font-bold text-brand-pearl mt-8 mb-4">Performance Fabrics</h2>
        <p><strong>Best for:</strong> Moisture-wicking, stretch, quick-dry<br/>
        <strong>Ideal for:</strong> Sports teams, athletic wear<br/>
        <strong>Care:</strong> Machine washable, no ironing required</p>
        
        <h2 className="text-2xl font-heading font-bold text-brand-pearl mt-8 mb-4">Heavy-Duty Fabrics</h2>
        <p><strong>Best for:</strong> Industrial strength, safety features<br/>
        <strong>Ideal for:</strong> Factory workers, construction crews<br/>
        <strong>Care:</strong> Durable, can withstand heavy washing</p>
      </>
    }
  />
);

export const SizeGuidePage = () => (
  <SimpleTextPage
    title="Size Guide"
    content={
      <>
        <h2 className="text-2xl font-heading font-bold text-brand-pearl mb-4">Finding Your Perfect Fit</h2>
        <p>Use this guide to determine your size for Rudra Apparel products.</p>
        
        <h2 className="text-2xl font-heading font-bold text-brand-pearl mt-8 mb-4">How to Measure</h2>
        <p><strong>Chest:</strong> Measure around the fullest part of your chest, keeping the tape measure horizontal.<br/>
        <strong>Waist:</strong> Measure around your natural waistline.<br/>
        <strong>Hip:</strong> Measure around the fullest part of your hips.<br/>
        <strong>Inseam:</strong> Measure from the crotch to the bottom of the leg.</p>
        
        <h2 className="text-2xl font-heading font-bold text-brand-pearl mt-8 mb-4">Men's Size Chart (inches)</h2>
        <div className="overflow-x-auto">
          <table className="w-full border border-brand-pearl/20">
            <thead className="bg-brand-timberwolf">
              <tr>
                <th className="p-3 text-left border border-brand-pearl/20">Size</th>
                <th className="p-3 text-left border border-brand-pearl/20">Chest</th>
                <th className="p-3 text-left border border-brand-pearl/20">Waist</th>
                <th className="p-3 text-left border border-brand-pearl/20">Hip</th>
              </tr>
            </thead>
            <tbody>
              <tr><td className="p-3 border border-brand-pearl/20">S</td><td className="p-3 border border-brand-pearl/20">36-38</td><td className="p-3 border border-brand-pearl/20">30-32</td><td className="p-3 border border-brand-pearl/20">36-38</td></tr>
              <tr><td className="p-3 border border-brand-pearl/20">M</td><td className="p-3 border border-brand-pearl/20">38-40</td><td className="p-3 border border-brand-pearl/20">32-34</td><td className="p-3 border border-brand-pearl/20">38-40</td></tr>
              <tr><td className="p-3 border border-brand-pearl/20">L</td><td className="p-3 border border-brand-pearl/20">40-42</td><td className="p-3 border border-brand-pearl/20">34-36</td><td className="p-3 border border-brand-pearl/20">40-42</td></tr>
              <tr><td className="p-3 border border-brand-pearl/20">XL</td><td className="p-3 border border-brand-pearl/20">42-44</td><td className="p-3 border border-brand-pearl/20">36-38</td><td className="p-3 border border-brand-pearl/20">42-44</td></tr>
            </tbody>
          </table>
        </div>
        
        <h2 className="text-2xl font-heading font-bold text-brand-pearl mt-8 mb-4">Custom Sizing</h2>
        <p>For bespoke orders, we take precise measurements during consultation to ensure a perfect fit. Our team will guide you through the measurement process.</p>
      </>
    }
  />
);

export const CareInstructionsPage = () => (
  <SimpleTextPage
    title="Care Instructions"
    content={
      <>
        <h2 className="text-2xl font-heading font-bold text-brand-pearl mb-4">Caring for Your Uniforms</h2>
        <p>Proper care extends the life of your garments and maintains their professional appearance.</p>
        
        <h2 className="text-2xl font-heading font-bold text-brand-pearl mt-8 mb-4">General Washing Guidelines</h2>
        <ul className="list-disc pl-6 space-y-2">
          <li>Separate colors from whites</li>
          <li>Turn garments inside out before washing</li>
          <li>Use mild detergent</li>
          <li>Wash in cold or warm water (not hot)</li>
          <li>Remove promptly after washing to prevent wrinkles</li>
        </ul>
        
        <h2 className="text-2xl font-heading font-bold text-brand-pearl mt-8 mb-4">Drying</h2>
        <ul className="list-disc pl-6 space-y-2">
          <li>Tumble dry on low heat or hang dry</li>
          <li>Avoid over-drying to prevent shrinkage</li>
          <li>Remove from dryer while slightly damp for easier ironing</li>
        </ul>
        
        <h2 className="text-2xl font-heading font-bold text-brand-pearl mt-8 mb-4">Ironing & Storage</h2>
        <ul className="list-disc pl-6 space-y-2">
          <li>Iron while slightly damp for best results</li>
          <li>Use appropriate heat setting for fabric type</li>
          <li>Hang uniforms on proper hangers to maintain shape</li>
          <li>Store in a cool, dry place away from direct sunlight</li>
        </ul>
        
        <h2 className="text-2xl font-heading font-bold text-brand-pearl mt-8 mb-4">Stain Removal</h2>
        <p>Treat stains immediately. Blot (don't rub) fresh stains. For tough stains, consult a professional dry cleaner.</p>
      </>
    }
  />
);

export const FAQPage = () => (
  <SimpleTextPage
    title="Frequently Asked Questions"
    content={
      <>
        <h2 className="text-2xl font-heading font-bold text-brand-pearl mb-4">General Questions</h2>
        
        <h3 className="text-xl font-heading font-semibold text-brand-pearl mt-6 mb-2">What is the minimum order quantity for bespoke uniforms?</h3>
        <p>For bespoke manufacturing, our minimum order quantity is typically 50 units. For bulk/private label orders, the minimum is 500 units.</p>
        
        <h3 className="text-xl font-heading font-semibold text-brand-pearl mt-6 mb-2">How long does it take to manufacture custom uniforms?</h3>
        <p>Standard bespoke orders take 20-30 days from sample approval. Large bulk orders may require 30-45 days depending on complexity and volume.</p>
        
        <h3 className="text-xl font-heading font-semibold text-brand-pearl mt-6 mb-2">Do you provide fabric samples?</h3>
        <p>Yes, we provide fabric swatches and physical samples during the consultation process for bespoke orders.</p>
        
        <h2 className="text-2xl font-heading font-bold text-brand-pearl mt-8 mb-4">Ordering & Payment</h2>
        
        <h3 className="text-xl font-heading font-semibold text-brand-pearl mt-6 mb-2">What payment methods do you accept?</h3>
        <p>We accept online payments via Razorpay (credit/debit cards, UPI, net banking). For bulk orders, we also offer bank transfer and flexible payment terms.</p>
        
        <h3 className="text-xl font-heading font-semibold text-brand-pearl mt-6 mb-2">Can I cancel or modify my order?</h3>
        <p>Ready-to-wear orders can be cancelled before shipping. Bespoke orders can be modified during the design phase but cannot be cancelled once production begins.</p>
        
        <h2 className="text-2xl font-heading font-bold text-brand-pearl mt-8 mb-4">Shipping & Returns</h2>
        
        <h3 className="text-xl font-heading font-semibold text-brand-pearl mt-6 mb-2">Do you ship internationally?</h3>
        <p>Currently, we ship only within India. For international orders, please contact us directly.</p>
        
        <h3 className="text-xl font-heading font-semibold text-brand-pearl mt-6 mb-2">What if the uniform doesn't fit?</h3>
        <p>For ready-to-wear items, you can exchange within 7 days. For bespoke orders, we ensure proper fit through our measurement and sampling process. Any fit issues will be addressed during production.</p>
      </>
    }
  />
);